<script setup>
const props = defineProps({
  title: String,
  text: String,
  img: String,
})
</script>

<template>
  <div class="choose-card">
    <div class="choose-card__content relative flex-col flex">
      <h4 class="text-xxl">{{ title }}</h4>
      <p class="text-m">{{ text }}</p>
      <img :src="require(`../../assets/${img}`)" alt="card image" class="absolute" />
    </div>
  </div>
</template>

<style scoped lang="scss">
.choose-card {
  display: table-cell;
  top: 0;
  transition: all 0.2s ease;
  perspective: 1000px;
  transform-style: preserve-3d;

  &__content {
    padding: 4.514vw 2.847vw 2.986vw;
    position: relative;
    height: clamp(452px, 31.389vw, 2500px);
    color: #F5F5F7;
    transition: all 0.2s ease;
    transform-style: preserve-3d;
    overflow: hidden;
    border-radius: clamp(41px, 2.847vw, 205px);
    box-shadow: 0px 4px 18px 0px rgba(255, 255, 255, 0.25), 0px 0px 40px 1px rgba(255, 255, 255, 0.10);
  }
  img {
    width: 100%;
    height: 100%;
    z-index: 0;
    top: 0;
    left: 0;
  }
  h4, p {
    position: relative;
    z-index: 1;
  }
  h4 {
    width: 60%;
    min-width: 300px;
  }
  p {
    width: 60%;
    margin: auto 0 0 auto;
  }
}

@media (min-width: 769px) {
  .choose-card:hover {
    animation: rotateReverse 2s infinite linear;
    .choose-card__content {
      animation: rotate 2s infinite linear;
      transform: rotateX(5deg);
    }
  }
}

@keyframes rotateReverse {
  49.7222% {
    transform: rotateZ(-179deg);
  }
  50% {
    transform: rotateZ(-180deg);
  }
  100% {
    transform: rotateZ(-360deg);
  }
}
@keyframes rotate {
  49.7222% {
    transform: rotateX(3deg) rotateZ(179deg);
  }
  50% {
    transform: rotateX(3deg) rotateZ(180deg);
  }
  100% {
    transform: rotateX(3deg) rotateZ(360deg);
  }
}

@media (max-width: 1024px) {
  .choose-card img {
    height: 100%;
    width: auto;
    min-width: 100%;
  }
}
@media (max-width: 768px) {
  .choose-card {
    display: block;
    width: 100%;
    h4 {
      width: 100%;
    }
    p {
      font-size: 18px;
      font-weight: 500;
      line-height: normal;
      width: 100%;
    }
    img {
      left: 50%;
      transform: translateX(-50%);
    }
    &__content {
      border-radius: 15px;
      padding: 50px 31px 22px;
    }
  }
}
</style>